import { useTurnOffItemTime } from './useTurnOffItemTime';
import { useTurnOffProductLang } from './useTurnOffProductLang';

import type { ITurnOffItemTime } from 'features/menu-page/domain';

export function useTurnOffProduct(props: Props) {
  const { turnOffCTA } = props;

  const turnOffItemTime = useTurnOffItemTime({ turnOffCTA });

  const lang = useTurnOffProductLang();

  return {
    lang,
    ...turnOffItemTime,
  };
}

interface Props {
  turnOffCTA: (p: ITurnOffItemTime) => void;
}
